module.exports = __webpack_public_path__ + "img/logo_cnp.1bf2ff0a.png";